import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootSaga from '../sagas';
import reducers from '../reducers';

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware, routeMiddleware];

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['layout'],
};

export default function configureStore(initialState = {}) {
    const persistedReducer = persistReducer(persistConfig, reducers);

    const store = createStore(
        persistedReducer,
        initialState,
        composeWithDevTools(applyMiddleware(...middlewares)),
    );

    const persistor = persistStore(store);

    sagaMiddleware.run(rootSaga);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers/index', () => {
            // eslint-disable-next-line global-require
            const nextRootReducer = require('../reducers');
            store.replaceReducer(nextRootReducer);
        });
    }

    return { store, persistor };
}

const { store, persistor } = configureStore();

export {
    store,
    persistor,
    history,
};
